import React, { useState, useEffect } from 'react';
import { Container, Box, Grid, useTheme, useMediaQuery } from '@mui/material';
import Footer from '../components/resuableComponents/Footer';
import Login from '../components/resuableComponents/Login';
import { AutoComplete, Divider } from 'antd';
import { fetchHotel } from '../reducers/HomeReducer';
import { useDispatch } from 'react-redux';
import Carousels from '../components/resuableComponents/Carousels';
import { fetchBusCityDispatch } from '../reducers/BusReducer';
import hotelIcon from '../assets/images/hotelIcon.svg';
import mealIcon from '../assets/images/mealIcon.svg';
import transport from '../assets/images/transport.svg';
import tour from '../assets/images/tour.svg';
import itinerary from '../assets/images/itinerary.svg';
import flight from '../assets/images/flight.svg';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import SliderPage from '../components/resuableComponents/SliderPage';
const Option = AutoComplete.Option;
const popularFlight = [
	{
		name: 'Indigo Airlines',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/6E.png',
	},
	{
		name: 'Air India',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/AI.png',
	},
	{
		name: 'Air India Express',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/IX.png',
	},
	{
		name: 'Air Asia India',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/I5.png',
	},
	{
		name: 'Akasa Air',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/QP.png',
	},
	{
		name: 'Vistara Airline',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/UK.png',
	},
	{
		name: 'SpiceJet',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/SG.png',
	},
];
const popularDes = [
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
];
const slider = [
	'https://wallpapercave.com/wp/wp8030634.jpg',
	'https://images.pexels.com/photos/2305226/pexels-photo-2305226.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
	'https://images.pexels.com/photos/18201084/pexels-photo-18201084/free-photo-of-sky-tower-over-buildings-in-auckland-at-sunset.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
	'https://wallpapercave.com/wp/wp9388467.jpg',
];
const tours = [
	{
		image: hotelIcon,
		title: 'Accommodation',
		desc: 'Comfortable & convenient hotels cherry picked by our hotel management team',
	},
	{
		image: mealIcon,
		title: 'All meals',
		desc: "Eat to your heart's content Breakfast. Lunch. Dinner.",
	},
	{
		image: transport,
		title: 'On-tour transport',
		desc: 'Our itineraries include all rail, sea and road transport as part of the itinerary so you can enjoy tension free',
	},
	{
		image: tour,
		title: 'Tour managers',
		desc: 'We have an exclusive team of 350 tour managers specialising in India and World tours',
	},
	{
		image: itinerary,
		title: 'Best value itinerary',
		desc: 'Our dedicated product & destination research team spends hours curating the best value for money itineraries',
	},
	{
		image: flight,
		title: 'To and from airfare',
		desc: 'MusafirBazar tours are inclusive of airfare from many hubs within India unless you pick the joining-leaving option',
	},
];
const LandingPage = () => {
	const dispatch = useDispatch();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	useEffect(() => {
		let form = {};
		dispatch(fetchBusCityDispatch(form));
		dispatch(fetchHotel(form));
	}, []);

	return (
		<div>
			<header className='App-header'>
				<Navbar />
				<SliderPage images={slider} />
				<Box style={{ marginTop: 50 }}>
					<h1 style={{ textAlign: 'center', fontWeight: '500', fontSize: 40 }}>
						Popular Destination
					</h1>
					<br></br>
					<br></br>
					<Container>
						<Carousels />
					</Container>
				</Box>
				<Container className='m'>
					<Box style={{ padding: 20 }}>
						<h1
							style={{ textAlign: 'center', color: '#EC5B24', marginTop: 20 }}>
							Best Flight Deals Of The Day
						</h1>
						<Grid
							container
							spacing={4}
							style={{ marginTop: 30, marginBottom: 30 }}>
							{popularDes.map((i) => {
								return (
									<Grid item xs={12} lg={4}>
										{' '}
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<img
												src={i.image}
												style={{ height: 45, width: 45, borderRadius: 25 }}
											/>
											<Box style={{ marginLeft: 10 }}>
												<span>{i.name}</span>
												<br />
												<span>To</span>:{' '}
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
													}}>
													{i.to[0]}
												</span>{' '}
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[1]}
												</span>
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[2]}
												</span>
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[3]}
												</span>
											</Box>
										</Box>
									</Grid>
								);
							})}
						</Grid>
					</Box>
				</Container>
				<Container className='m'>
					<Box style={{ padding: 20 }}>
						<h1
							style={{
								textAlign: 'center',
								color: '#EC5B24',
								marginTop: 20,
								fontSize: 26,
							}}>
							Popular Flight Routes
						</h1>
						<Grid
							container
							spacing={4}
							style={{ marginTop: 30, marginBottom: 30 }}>
							{popularDes.map((i) => {
								return (
									<Grid item xs={12} lg={4}>
										{' '}
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<img
												src={i.image}
												style={{ height: 45, width: 45, borderRadius: 25 }}
											/>
											<Box style={{ marginLeft: 10 }}>
												<span>{i.name}</span>
												<br />
												<span>To</span>:{' '}
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
													}}>
													{i.to[0]}
												</span>{' '}
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[1]}
												</span>
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[2]}
												</span>
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[3]}
												</span>
											</Box>
										</Box>
									</Grid>
								);
							})}
						</Grid>
					</Box>
				</Container>
				<Container style={{ marginBottom: 40 }}>
					<h2
						style={{
							textAlign: 'center',
							fontWeight: 600,
							color: 'rgb(114, 28, 129)',
							fontSize: matches ? 22 : 26,
						}}>
						All inclusive tours, Chalo Bag Bharo Nikal Pado!
					</h2>
					<br />
					<br />
					<Grid container spacing={4}>
						{tours.map((r) => {
							return (
								<Grid item xs={12} lg={4}>
									<Box style={{ textAlign: 'center' }}>
										<img src={r.image} style={{ display: 'inline' }} />
										<h3
											style={{
												color: '#721c81',
											}}>
											{r.title}
										</h3>
										<span style={{ fontSize: 16 }}>{r.desc}</span>
									</Box>
								</Grid>
							);
						})}
					</Grid>
				</Container>
				<Container className='m2'>
					<Box style={{ padding: 20 }}>
						<h1
							style={{
								textAlign: 'center',
								color: '#EC5B24',
								marginTop: 20,
								fontSize: 26,
							}}>
							Popular Domestic Airlines
						</h1>
						<Grid container spacing={2} style={{ marginTop: 30 }}>
							{popularFlight.map((i) => {
								return (
									<Grid item xs={6} lg={2}>
										<Box>
											<img src={i.image} />
											<br />
											<p style={{ marginTop: 15, fontSize: 12 }}>{i.name}</p>
										</Box>
									</Grid>
								);
							})}
						</Grid>
					</Box>
				</Container>
				<Divider style={{ border: '1px solid lightgrey' }} />
				<Footer />
			</header>
			<Login />
		</div>
	);
};

export default LandingPage;
